"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSlotStatusPostRequest = updateSlotStatusPostRequest;
async function updateSlotStatusPostRequest(branchId, userId, payload) {
    const data = {
        "status": payload.status,
    };
    try {
        const response = await fetch(`/dashboard/${userId}/workrequests/${payload.slotId}?c=${branchId}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        return await response.json();
    }
    catch (err) {
        throw err;
    }
}
